import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentsNavigationVue = _resolveComponent("ComponentsNavigationVue")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ComponentsFooterVue = _resolveComponent("ComponentsFooterVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_ComponentsNavigationVue, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_ComponentsFooterVue, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}